import Api from '@api/xiao_xiong/marketing'
import {
  IMG_PRO,
  IMG_PRO_FULL,
  IMG_ZUNXIANG,
  IMG_ZUNXIANG_FULl,
  PRO_HOTEL_TEXT,
  PRO_TEXT,
  SHOP_PRODUCTS_PATH,
  SIDA_FREE_FOR_LIMIT_TIME,
  SIDA_PAID_POST
} from '@constant'
import {
  isHonorable,
  isHotelProperty,
  isNormal,
  isOnlineShop,
  isPureUltimate,
  isStandard,
  isUltimate
} from '@merchant-backend/util'
import { Modal } from 'hljd'
import { hashHistory } from 'react-router'
import { getMerchantInfo } from '..'
import { isTelSaleCityMerchant } from './merchantInfo'
import { isSiDaMember, isSiDaTeam } from './property'

/**
 * 获取旗舰版相关信息
 */
export const getProInfo = async () => {
  const { success, data } = await Api.getProData()
  if (!success) {
    return
  }

  return data
}

/**
 * 非旗舰版提示弹窗
 */
export const notUltimateAlert = (
  content = `无法使用此功能，请升级至${getProTitle()}！`
) => {
  Modal.confirm({
    title: content,
    iconType: 'info-circle-o',
    okText: `开通${getProTitle()}`,
    cancelText: '关闭',
    onOk() {
      hashHistory.push(SHOP_PRODUCTS_PATH)
    }
  })
}

/**
 * 当前是否应该展示尊享版产品
 * 兼容当前产品类型与城市类型不符的商家
 * 如之前是非电销城市购买了旗舰版未到期，现在又变成了电销城市，依然展示旗舰版
 */
export const shouldShowZunXiang = () => {
  return isHonorable() || (!isPureUltimate() && isTelSaleCityMerchant())
}

/**
 * 是否为店铺服务费或旗舰版
 */
export const isOnlineShopOrUltimate = () => {
  return isOnlineShop() || isUltimate()
}

// 是否为限时免费
export const isFreeLimitTime = () => {
  return getMerchantInfo().four_mode === SIDA_FREE_FOR_LIMIT_TIME
}
// 是否为付费后置
export const isPaidPost = () => {
  return getMerchantInfo().four_mode === SIDA_PAID_POST
}

/**
 * 是否是旗舰版或者标准版
 */
export const isUltimateOrStandard = () => {
  return isUltimate() || isStandard()
}

/**
 * 是否是旗舰版或者标准版（不考虑电销城市）
 */
export const isPureUltimateOrStandard = () => {
  return isPureUltimate() || isStandard()
}

export const getProText = () => {
  return isHotelProperty() ? PRO_HOTEL_TEXT : PRO_TEXT
}

export const showZunXiang = () => {
  return isTelSaleCityMerchant() && (isNormal() || isHonorable())
}

/**
 * 获取旗舰版标题名字
 * 根据四大个人团队/其他类目区分不同的名称
 * 优先取当前产品类型，当前无产品再判断电销城市商家引导为尊享版
 */
export const getProTitle = (withShopType = false, suffix) => {
  const suffixText = '（付费）'
  let shopType = '店铺'
  if (isSiDaMember()) {
    shopType = '个人'
  }

  if (isSiDaTeam()) {
    shopType = '团队'
  }

  let proType = '商家服务'

  return (withShopType ? shopType : '') + proType + (suffix ? suffixText : '')
}

/**
 * 店铺版本的介绍文案
 */
export const getShopProductData = () => {
  const telSaleCityMerchant = isTelSaleCityMerchant()

  const ultimateData = {
    title: getProTitle(),
    des: getProText()
  }

  const zunXiangData = {
    title: '商家服务（付费）',
    des: '商家必备经营神器，营销工具+流量投放，轻松搞定，省心省力'
  }

  // 基础版
  if (isNormal()) {
    if (telSaleCityMerchant) {
      return zunXiangData
    } else {
      return ultimateData
    }
  }

  // 标准版
  if (isStandard()) {
    return {
      title: '店铺标准版',
      des: getProText()
    }
  }

  // 旗舰版
  if (isPureUltimate()) {
    return {
      title: getProTitle(),
      des: getProText()
    }
  }

  if (isHonorable()) {
    return zunXiangData
  }

  // 这个 return 应该进不来
  return ultimateData
}

/**
 * 获取旗舰版/尊享版标签图片
 */
export const getProImg = () => {
  if (isTelSaleCityMerchant()) {
    return {
      full: IMG_ZUNXIANG_FULl,
      tag: IMG_ZUNXIANG
    }
  }

  return {
    full: IMG_PRO_FULL,
    tag: IMG_PRO
  }
}
